export const MIN_PRINTOUT_QR_CODE_SIZE_MM = 15;
export const MAX_PRINTOUT_QR_CODE_SIZE_MM = 60;
export const DEFAULT_PRINTOUT_QR_CODE_SIZE_MM = 22;

export interface PrintoutQrCodeNodeAttrs {
    url?: string | null;
    sizeMm?: number;
}

export const clampPrintoutQrCodeSizeMm = (
    value: unknown,
    fallback = DEFAULT_PRINTOUT_QR_CODE_SIZE_MM,
): number => {
    const numberValue = typeof value === "number" ? value : Number(value);

    if (!Number.isFinite(numberValue)) return fallback;

    return Math.min(
        MAX_PRINTOUT_QR_CODE_SIZE_MM,
        Math.max(MIN_PRINTOUT_QR_CODE_SIZE_MM, Math.round(numberValue)),
    );
};

export const getPrintoutQrCodeAttrs = (
    attrs: Partial<PrintoutQrCodeNodeAttrs> = {},
): Required<PrintoutQrCodeNodeAttrs> => ({
    url: typeof attrs.url === "string" ? attrs.url.trim() || null : null,
    sizeMm: clampPrintoutQrCodeSizeMm(attrs.sizeMm),
});
